export const tableColumns = [
  { label: "Идентификатор МО", value: "mobindId" },
  { label: "Идентификатор пациента", value: "personId" },
  { label: "Фамилия, имя, отчество пациента", value: "fullName" },
  { label: "Дата рождения пациента", value: "birthDate" },
  { label: "Возраст пациента", value: "age" },
  { label: "Пол пациента", value: "gender" },
  { label: "Номер телефона", value: "phoneNumber" },
  { label: "Социальный статус пациента", value: "socialStatus" },
  { label: "Группа инвалидности пациента", value: "disabilityGroup" },
  { label: "Набор социальных услуг", value: "socialServices" },
  { label: "Прикрепление к медицинской организации", value: "mobind" },
  { label: "Номер участка", value: "areaNumber" },
  { label: "Адрес места жительства пациента", value: "address" },
  {
    label: "Достигнут стабильный клинический эффект за год, предшествующий отчету",
    value: "stableClinicalEffect",
  },
  {
    label: "Достигнут стабильный клинический эффект с начала текущего года",
    value: "stableClinicalEffectThisYear",
  },
  {
    label: "Дата ДН по БСК с начала текущего года",
    value: "lastYearBSKFollowUpDate",
  },
  { label: "ПМО и ДОГВН с начала текущего года", value: "lastYearPMOOrDGVN" },
  { label: "Наличие диагноза I48.0-I48.9", value: "hasI48" },
  { label: "Д учет по диагнозу I48.0-I48.9", value: "hasDispensaryI48" },
  {
    label: "Дата следующей диспансерной явки по I48.0-I48.9",
    value: "i48NextPlannedVisitDate"
  },
  { label: "Фактический уровень ЧСС", value: "actualHeartRate" },
  {
    label: "Количество баллов по шкале CHA2DS2-VASc у пациентов с ФП",
    value: "chA2DS2VAScScore",
  },
  { label: "Антикоагулянтная терапия", value: "anticoagulantTherapy" },
  { label: "Наличие диагноза I50.0-I50.9", value: "hasI50" },
  { label: "Д учет по диагнозу I50.0-I50.9", value: "hasDispensaryI50" },
  {
    label: "Дата следующей диспансерной явки по I50.0-I50.9",
    value: "i50NextPlannedVisitDate"
  },
  { label: "Наличие диагноза I10-I13", value: "hasI10_I13" },
  { label: "Д учет по диагнозу I10-I13", value: "hasDispensaryI10_I13" },
  {
    label: "Дата следующей диспансерной явки по I10-I13",
    value: "i10I13NextPlannedVisitDate",
  },
  {
    label: "Целевой уровень систолического АД",
    value: "targetSystolicPressure"
  },
  {
    label: "Фактический уровень систолического АД",
    value: "actualSystolicPressure"
  },
  {
    label: "Целевой уровень диастолического АД",
    value: "targetDiastolicPressure"
  },
  {
    label: "Фактический уровень диастолического АД",
    value: "actualDiastolicPressure"
  },
  {
    label: "Целевой уровень АД достигнут",
    value: "targetBloodPressureAchieved",
  },
  { label: "Наличие диагноза I65.2", value: "hasI65_2" },
  { label: "Д учет по диагнозу I65.2", value: "hasDispensaryI65_2" },
  {
    label: "Дата следующей диспансерной явки по I65.2",
    value: "i652NextPlannedVisitDate"
  },

  { label: "Наличие диагноза I20, I25", value: "hasI20_I25" },
  { label: "Д учет по диагнозу I20, I25", value: "hasDispensaryI20_I25" },
  {
    label: "Дата следующей диспансерной явки по I20, I25",
    value: "i20I25NextPlannedVisitDate"
  },
  { label: "Наличие диагноза I26.0, I26.9", value: "hasI26" },
  { label: "Д учет по диагнозу I26.0, I26.9", value: "hasDispensaryI26" },
  {
    label: "Дата следующей диспансерной явки по I26.0, I26.9",
    value: "i26NextPlannedVisitDate"
  },
  { label: "Наличие диагноза E78", value: "hasE78" },
  { label: "Д учет по диагнозу E78", value: "hasDispensaryE78" },
  {
    label: "Дата следующей диспансерной явки по E78",
    value: "e78NextPlannedVisitDate"
  },
  { label: "Фактический уровень ЛПНП", value: "actualLDL" },
  { label: "Дата проведения ЧКВ", value: "pciDate" },
  { label: "Дата проведения АКШ и МКШ", value: "cabgDate" },
  { label: "Дата проведения КАГ", value: "cagDate" },
  {
    label: "Дата проведения дуплексного сканирования БЦА",
    value: "duplexScanDate",
  },
  { label: "Дата консультации нейрохирурга", value: "neurosurgeonConsultation" },
  {
    label: "Дата операции по поводу атеросклероза БЦА",
    value: "atherosclerosisOperations",
  },
  { label: "Наличие в анамнезе I21,I22", value: "hasHistoryI21_I22" },
  { label: "Д учет по диагнозу I21,I22", value: "hasDispensaryI21_I22" },
  { label: "Дата последней госпитализации с I21, I22", value: "lastEpicrisisI21_I22" },

  { label: "Наличие в анамнезе I60.0-I64.9", value: "hasHistoryI60_I64" },
  { label: "Д учет по диагнозу I60.0-I64.9", value: "hasDispensaryI60_I64" },
  {
    label: "Дата последней госпитализации с I60.0-I64.9",
    value: "lastEpicrisisI60_I64",
  },
  { label: "Дата последней госпитализации по экстренным показаниям с I48.0-I48.9", value: "lastEpicrisisI48" },
  { label: "Дата последней госпитализации по экстренным показаниям с I10-I13", value: "lastEpicrisisI10_I13" },
  { label: "Дата последней госпитализации по экстренным показаниям с I65.2", value: "lastEpicrisisI65_2" },
  { label: "Дата последней госпитализации по экстренным показаниям с I20,I25", value: "lastEpicrisisI20_I25" },
  { label: "Дата последней госпитализации по экстренным показаниям с I26.0,I26.9", value: "lastEpicrisisI26" },
  { label: "Количество вызовов СМП по диагнозам I00-I99 за год, предшествующий отчету", value: "emergencyCallsI00_I99" },
  { label: "Количество вызовов СМП с диагнозом I00-I99 за текущий год", value: "emergencyCallsI00_I99ThisYear" },
  { label: "Наличие диагноза E10-E11", value: "hasE10_E11" },
  { label: "Д учет по диагнозу E10-E11", value: "hasDispensaryE10_E11" },
  {
    label: "Дата следующей диспансерной явки по E10-E11",
    value: "e10E11NextPlannedVisitDate"
  },
  { label: "Фактический уровень НвА1с", value: "actualHbA1c" },
  { label: "Наличие диагноза J44.0-J44.9", value: "hasJ44" },
  { label: "Д учет по диагнозу J44.0-J44.9", value: "hasDispensaryJ44" },
  {
    label: "Дата следующей диспансерной явки по J44.0-J44.9",
    value: "j44NextPlannedVisitDate"
  },
  { label: "Наличие диагноза N18.1-N18.9", value: "hasN18" },
  { label: "Д учет по диагнозу N18.1-N18.9", value: "hasDispensaryN18" },
  {
    label: "Дата следующей диспансерной явки по N18.1-N18.9",
    value: "n18NextPlannedVisitDate"
  },
  { label: "Дата исключения из регистра", value: "registryExclusionDate" },
];
